module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"tariffExpired":"Tariff has expired","renewTariff":"Renew tariff"}}')
  delete Component.options._Ctor
}
